import data from '../data'
import requestToBOAction from './requestToBO.action'
import { wishTriggers } from '../main'
import { dlWishlistAddEvent } from '../../events/wishlist/dl.wishlist.add.event'

const addToWishlistAction = (product) => {
  product.addedToMeta = !!data.customerId
  product.deletedFromMeta = false

  const deletedP = data.products.find(item => item.sku === product.sku)

  if (deletedP) {
    deletedP.deletedFromMeta = false
    data.products.splice(data.products.indexOf(deletedP), 1, deletedP)
  } else {
    data.products.push(product)
  }

  const requestData = {}

  requestData.sku = product.sku
  if (data.customerId) {
    requestData.customer_id = data.customerId
    requestData.email = data.customerEmail
  }

  requestToBOAction('ADD', requestData)

  wishTriggers.emitEvent('listUpdated', [data.products])
  wishTriggers.emitEvent(`list:${product.sku}:add`)

  // analytic
  let imageUrl = product.image.slice(0, product.image.lastIndexOf('.')) + '_300x' + product.image.slice(product.image.lastIndexOf('.'))
  if (!/https:/.test(imageUrl)) {
    imageUrl = 'https:' + imageUrl
  }

  const lastWishItems = [{
    Name: product.title,
    product_id: product.id,
    URL: 'https://www.elephantstock.com' + product.url,
    ImageURL: imageUrl,
    Count: +product.count || 0
  }]

  const itemsReverse = data.products.slice().reverse()
  let c = 1
  for (let i = 0; c < 3 && i < itemsReverse.length; i++) {
    const item = itemsReverse[i]
    if (item.sku !== product.sku && !item.deletedFromMeta) {
      let imageUrl = item.image.slice(0, item.image.lastIndexOf('.')) + '_300x' + item.image.slice(item.image.lastIndexOf('.'))
      if (!/https:/.test(imageUrl)) {
        imageUrl = 'https:' + imageUrl
      }

      lastWishItems.push(
        {
          Name: item.title,
          product_id: item.id,
          URL: 'https://www.elephantstock.com' + item.url,
          ImageURL: imageUrl,
          Count: +item.count || 0
        }
      )
      c++
    }
  }

  dlWishlistAddEvent(product, lastWishItems)
}

export default addToWishlistAction
